<template>
  <div class="vx-card">
    <div class="vx-card__body card-body">
      <div class="vx-row mb-6">
        <div class="vx-col w-full mb-2">
          <vs-button
            @click="createFAQcat()"
            class="bg_l_green"
            v-has-permission="permission269"
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="ico" />
            {{ $t("CreateNewFAQCategory") }}
          </vs-button>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full mb-base">
          <data-grid
            ref="grid"
            stripe
            :data-source="gridDataSource"
            :search-data="gridSearchData"
            :columns="[
              { title: $t('Name'), sort: 'Name' },
              { title: $t('CreateOn'), sort: 'CreateOn' },
              { title: $t('Action') },
            ]"
          >
            <template slot-scope="{ row }">
              <td style="width: 50%">
                {{ row.name }}
              </td>
              <td style="width: 25%; direction: ltr">
                {{ row.createOn.split(" ")[0] }}<br />{{
                  row.createOn.split(" ")[1]
                }}
              </td>
              <td style="width: 22%">
                <vs-button
                  radius
                  color="success"
                  size="small"
                  type="gradient"
                  icon-pack="feather"
                  icon="icon-edit"
                  @click.prevent="editFAQCat(row)"
                  class="ml-4 d-inline"
                  v-has-permission="permission270"
                ></vs-button>
                <vs-button
                  radius
                  color="danger"
                  size="small"
                  type="gradient"
                  icon-pack="feather"
                  icon="icon-x"
                  @click.prevent="deleteFAQCategory(row.id)"
                  class="d-inline"
                  v-has-permission="permission271"
                ></vs-button>
              </td>
            </template>
          </data-grid>
        </div>
      </div>
      <modify-popup
        :show="ModifyPopup"
        :model="modalModel"
        @finish="onfinish"
        @close="closeModifyPopup"
      ></modify-popup>
    </div>
  </div>
</template>
<style lang="scss">
.con-vs-checkbox {
  display: inline-flex;
  margin: 0px !important;
}
</style>
<script>
import { mapActions } from "vuex";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import ModifyPopup from "./ModifyPopup.vue";

export default {
  name: "Content_management_FAQcategory_Index",
  components: {
    DataGrid,
    ModifyPopup,
  },
  data() {
    return {
      permission269: "CreateFaqCategory",
      permission270: "ModifyFaqCategory",
      permission271: "DeleteFaqCategory",
      gridDataSource: {
        type: "app",
        service: "CMS/api/FaqCategoriesQuery",
      },
      gridSearchData: {
        keyword: "",
      },
      ModifyPopup: false,
      modalModel: {},
    };
  },
  methods: {
    ...mapActions({
      removeFAQCategory: "FAQcategory/remove",
    }),
    ////Open Modal In Create Mode
    createFAQcat() {
      this.modalModel = {};
      this.ModifyPopup = true;
    },
    //Open Modal In Edit Mode
    editFAQCat(model) {
      this.modalModel = {
        id: model.id,
        name: model.name,
        iconUrl: model.iconUrl,
        priority: model.priority,
        isActive: model.isActive,
      };
      this.ModifyPopup = true;
    },
    //Delete Method
    deleteFAQCategory(id) {
      this.$swal({
        title: "آیا از حذف این رکورد اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          this.removeFAQCategory(id).then(() => {
            this.$refs.grid.renderGrid();
          });
        }
      });
    },
    closeModifyPopup() {
      this.ModifyPopup = false;
    },
    onfinish() {
      this.closeModifyPopup();
      this.$refs.grid.renderGrid();
    },
  },
};
</script>
